//TODO Place auto-generated types here plus any other commonly used type for the feature

import type { BaseFetchListParams, PaginatedListData } from "../../../../services/types";

export const customerTagTypes: CustomerTagType[] = ["CustomerList"];
export type CustomerTagType = "CustomerList";
export type CustomersListApiResponse = /** status 200  */ PaginatedListData<CustomerRead>;
export type CustomersListApiArg = BaseFetchListParams & {
  companyContactEmail?: string;
  companyName?: string;
};
export type CustomersCreateApiResponse = /** status 201  */ CustomerCreateRead;
export type CustomersCreateApiArg = {
  createRequest: CustomerCreateRequest;
};
export type CustomersRetrieveApiResponse = /** status 200  */ CustomerRead;
export type CustomersRetrieveApiArg = {
  id: number;
};
export type CustomersUpdateApiResponse = /** status 200  */ CustomerUpdateRead;
export type CustomersUpdateApiArg = {
  /** A unique integer value identifying this customer. */
  id: number;
  updateRequest: CustomerUpdateRequest;
};
export type CustomersPartialUpdateApiResponse = /** status 200  */ CustomerUpdateRead;
export type CustomersPartialUpdateApiArg = {
  /** A unique integer value identifying this customer. */
  id: number;
  patchRequest: PatchedCustomerUpdateRequest;
};
export type CustomersDestroyApiResponse = unknown;
export type CustomersDestroyApiArg = {
  /** A unique integer value identifying this customer. */
  id: number;
};
export type Address = {
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};
export type AddressRead = {
  id: number;
  created_at: string;
  updated_at: string;
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};
export type Customer = {
  address: Address;
  company_name: string;
  company_contact_email: string;
};
export type CustomerRead = {
  id: number;
  address: AddressRead;
  created_at: string;
  updated_at: string;
  company_name: string;
  company_contact_email: string;
};
export type CreateAddress = {
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};
export type CreateAddressRead = {
  created_at: string;
  updated_at: string;
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};
export type CustomerCreate = {
  address: CreateAddress;
  company_name: string;
  company_contact_email: string;
};
export type CustomerCreateRead = {
  id: number;
  address: CreateAddressRead;
  created_at: string;
  updated_at: string;
  company_name: string;
  company_contact_email: string;
};
export type CreateAddressRequest = {
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};
export type CustomerCreateRequest = {
  address: CreateAddressRequest;
  company_name: string;
  company_contact_email: string;
};
export type CustomerUpdate = {
  address?: Address;
  company_name: string;
  company_contact_email: string;
};
export type CustomerUpdateRead = {
  id: number;
  address?: AddressRead;
  created_at: string;
  updated_at: string;
  company_name: string;
  company_contact_email: string;
};
export type AddressRequest = {
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};
export type CustomerUpdateRequest = {
  address?: AddressRequest;
  company_name: string;
  company_contact_email: string;
};
export type PatchedCustomerUpdateRequest = {
  address?: AddressRequest;
  company_name?: string;
  company_contact_email?: string;
};
